import React, { useState } from "react";
import PropTypes from "prop-types";
import TextareaAutosize from "react-textarea-autosize";
import { Label, Icon } from "semantic-ui-react";
import { size, compact, join, defaultTo } from "lodash";
import styles from "./styles.module.css";

const TextAreaInput = ({
	value,
	name,
	label,
	onChange,
	disabled = false,
	error,
	isPassword = false,
	minRows = 1,
	maxRows,
	showRequired = false,
	placeholder = "Escribe aquí...",
	showCount = false,
	maxLength,
	className = "",
}) => {
	const [show, setShow] = useState(false);

	return (
		<div className={styles.wrapper}>
			{label && (
				<div className={styles.labelRow}>
					<label className={styles.label}>
						{label}
						{showRequired && <span className={styles.required}> *</span>}
						{isPassword && (
							<Icon
								name={show ? "eye slash" : "eye"}
								className={styles.labelIcon}
								disabled={disabled}
								onClick={() => {
									return setShow(!show);
								}}
							/>
						)}
					</label>
					<div className={styles.labelActions}>
						{showCount && maxLength && (
							<span className={styles.charCount}>
								{size(value)}/{maxLength}
							</span>
						)}
					</div>
				</div>
			)}

			<div className={styles.inputWrapper}>
				<TextareaAutosize
					minRows={minRows}
					maxRows={maxRows}
					name={name}
					className={join(compact([styles.textarea, error && styles.error, className]), " ")}
					value={defaultTo(value, "")}
					onChange={onChange}
					disabled={disabled}
					placeholder={placeholder}
					style={{ WebkitTextSecurity: isPassword && !show ? "disc" : "none" }}
				/>

				<div className={styles.iconsContainer}>
					{value && !disabled && (
						<Icon
							name="close"
							className={styles.icon}
							onClick={() => {
								return onChange({ target: { name, value: "" } });
							}}
						/>
					)}
				</div>
			</div>

			{error && (
				<Label basic color="red" className={styles.errorLabel}>
					{error}
				</Label>
			)}
		</div>
	);
};

TextAreaInput.propTypes = {
	value: PropTypes.string,
	name: PropTypes.string,
	label: PropTypes.string,
	onChange: PropTypes.func,
	disabled: PropTypes.bool,
	error: PropTypes.string,
	isPassword: PropTypes.bool,
	showRequired: PropTypes.bool,
	minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	placeholder: PropTypes.string,
	showCount: PropTypes.bool,
	maxLength: PropTypes.number,
	className: PropTypes.string,
};

export default TextAreaInput;
